const PROMOTIONAL_SKELETON_LAYOUT = [
  { span: 2, large: true },
  { span: 2, large: true },
  { span: 1, large: false },
  { span: 1, large: false },
  { span: 1, large: false },
  { span: 1, large: false },
  { span: 1, large: false },
  { span: 1, large: false },
  { span: 1, large: false },
  { span: 1, large: false }
];

export const PromotionalSkeleton = () => {
  return (
    <div className="grid grid-cols-4 gap-1">
      {PROMOTIONAL_SKELETON_LAYOUT.map((item, index) => (
        <div
          key={index}
          className={[
            "skeleton rounded-lg bg-base-200",
            item.span === 2 ? "col-span-2" : "col-span-1",
            item.large ? "h-[104px]" : "h-16"
          ].join(" ")}
        />
      ))}
    </div>
  );
};
